import {
  MoreVertOutlined,
  EditOutlined,
  DeleteOutlined,
  VisibilityOutlined,
  PrintOutlined,
  NavigateNextOutlined,
  AssessmentOutlined,
  StarBorderOutlined,
  MoveToInboxOutlined,
  WorkspacePremiumOutlined,
  ContentCopyOutlined,
} from "@mui/icons-material";
import {
  Fade,
  IconButton,
  Menu,
  MenuItem,
  TableCellProps,
} from "@mui/material";
import { ChangeEvent, useState } from "react";
import { TableCellCustom } from "./CustomMenuItem.styled";
import { ConfirmationArea } from "../../confirmationArea/ConfirmationArea";

interface IMenuItemProps extends TableCellProps {
  id: string;
  handleToEdit?: (id: string) => void;
  handleToDelete?: (id: string) => void;
  handleToView?: (id: string) => void;
  handleToPrintOut?: (id: string) => void;
  handleToMessages?: (id: string) => void;
  handleToGenerateReport?: (id: string) => void;
  handleToNavigate?: (id: string) => void;
  navigateTitle?: string;
  handleSendAttachment?: (
    e: ChangeEvent<HTMLInputElement>,
    id: string,
  ) => Promise<void>;
  disableButton?: boolean;
  requestNumber?: string;
  isDraft?: boolean;
  notificationQuantity?: number;
  heaveMessages?: boolean;
  handleToFollowUp?: (id: string) => void;
  handleToResults?: (id: string) => void;
  handleToBestCollectors?: (id: string) => void;
  finished?: boolean;
  handleToDownloadPlantsReport?: (id: string) => void;
  handleToDownloadCollectorsReport?: (id: string) => void;
  handleToReception?: (id: string) => void;
  handleToEventsReport?: (id: string) => void;
  handleToResultsReport?: (id: string) => void;
  handleToGenerateCertificates?: (id: string) => void;
  handleToGenerateJudgesCertificates?: (id: string) => void;
  handleToDuplicate?: (id: string) => void;
}

const CustomMenuItem: React.FC<IMenuItemProps> = ({
  id,
  handleToEdit,
  handleToDelete,
  handleToView,
  handleToPrintOut,
  handleToNavigate,
  navigateTitle,
  disableButton = false,
  handleToFollowUp,
  handleToResults,
  handleToBestCollectors,
  finished,
  handleToDownloadPlantsReport,
  handleToDownloadCollectorsReport,
  handleToReception,
  handleToEventsReport,
  handleToResultsReport,
  handleToGenerateCertificates,
  handleToGenerateJudgesCertificates,
  handleToDuplicate,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [dialogDeleteOpen, setDialogDeleteOpen] = useState(false);

  const [menuOpen, setMenuOpen] = useState(true);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialogDelete = () => {
    setDialogDeleteOpen(false);
  };

  const handleOpenDialogDelete = () => {
    setDialogDeleteOpen(true);
  };

  return (
    <TableCellCustom size="small" id={id} sx={{ width: "10px" }}>
      <IconButton
        disabled={disableButton}
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        size="small"
      >
        <MoreVertOutlined fontSize="small" />
      </IconButton>
      <Menu
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open && menuOpen}
        onClose={handleClose}
        TransitionComponent={Fade}
        onClick={() => {
          setMenuOpen(true);
        }}
      >
        {/* 1. Ações Básicas e Cadastro */}
        {handleToEdit && (
          <MenuItem
            onClick={() => {
              handleToEdit(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <EditOutlined fontSize="small" />
            Editar
          </MenuItem>
        )}
        {handleToDelete && (
          <MenuItem
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onClick={() => {
              handleOpenDialogDelete();
              handleClose();
            }}
          >
            <DeleteOutlined fontSize="small" />
            Excluir
          </MenuItem>
        )}
        {handleToDuplicate && (
          <MenuItem
            onClick={() => {
              handleToDuplicate(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <ContentCopyOutlined fontSize="small" />
            Duplicar
          </MenuItem>
        )}
        {handleToView && (
          <MenuItem
            onClick={() => {
              handleToView(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <VisibilityOutlined fontSize="small" />
            Visualizar
          </MenuItem>
        )}
        {handleToNavigate && (
          <MenuItem
            onClick={() => {
              handleToNavigate(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <NavigateNextOutlined fontSize="small" />
            {navigateTitle || "Navegar"}
          </MenuItem>
        )}
        {handleToReception && (
          <MenuItem
            onClick={() => {
              handleToReception(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <MoveToInboxOutlined fontSize="small" />
            Recebimento de Plantas
          </MenuItem>
        )}

        {/* 2. Acompanhamento e Resultados */}
        {handleToFollowUp && (
          <MenuItem
            onClick={() => {
              handleToFollowUp(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <VisibilityOutlined fontSize="small" />
            Acompanhar
          </MenuItem>
        )}
        {handleToResults && finished && (
          <MenuItem
            onClick={() => {
              handleToResults(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <AssessmentOutlined fontSize="small" />
            Resultado
          </MenuItem>
        )}
        {handleToBestCollectors && finished && (
          <MenuItem
            onClick={() => {
              handleToBestCollectors(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <StarBorderOutlined fontSize="small" />
            Melhores Colecionadores
          </MenuItem>
        )}
        {handleToGenerateCertificates && finished && (
          <MenuItem
            onClick={() => {
              handleToGenerateCertificates(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <WorkspacePremiumOutlined fontSize="small" />
            Certificados
          </MenuItem>
        )}
        {handleToGenerateJudgesCertificates && finished && (
          <MenuItem
            onClick={() => {
              handleToGenerateJudgesCertificates(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <WorkspacePremiumOutlined fontSize="small" />
            Certificado Juizes
          </MenuItem>
        )}

        {/* 3. Relatórios PDF (últimos botões, todos com ícone de impressora) */}
        {handleToDownloadPlantsReport && (
          <MenuItem
            onClick={() => {
              handleToDownloadPlantsReport(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <PrintOutlined fontSize="small" />
            Relatório de Plantas
          </MenuItem>
        )}
        {handleToDownloadCollectorsReport && (
          <MenuItem
            onClick={() => {
              handleToDownloadCollectorsReport(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <PrintOutlined fontSize="small" />
            Relatório de Colecionadores
          </MenuItem>
        )}
        {handleToResultsReport && finished && (
          <MenuItem
            onClick={() => {
              handleToResultsReport(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <PrintOutlined fontSize="small" />
            Relatório de Resultados
          </MenuItem>
        )}
        {handleToEventsReport && (
          <MenuItem
            onClick={() => {
              handleToEventsReport(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <PrintOutlined fontSize="small" />
            Histórico de Eventos
          </MenuItem>
        )}
        {handleToPrintOut && (
          <MenuItem
            onClick={() => {
              handleToPrintOut(id);
              handleClose();
            }}
            sx={{
              fontSize: "0.875rem",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <PrintOutlined fontSize="small" />
            Gerar Cartão
          </MenuItem>
        )}
      </Menu>

      {handleToDelete && (
        <ConfirmationArea
          dialogOpen={dialogDeleteOpen}
          id={id}
          title="Deseja realmente excluir o item?"
          message=""
          key={`dialog-${id}`}
          handleConfirmation={handleToDelete}
          deny={handleCloseDialogDelete}
        />
      )}
    </TableCellCustom>
  );
};

export { CustomMenuItem };
